import { forwardRef } from 'react';
import Avatar from './avatar';
import Body from './body';
import Button from './button';
import CardInternal from './card-internal';
import Footer from './footer';
import Header from './header';
import HeadstoneAvatar from './headstone-avatar';
const Card = forwardRef(CardInternal);
const CardNamespace = Object.assign(Card, {
    Avatar,
    Body,
    Button,
    Footer,
    Header,
    HeadstoneAvatar,
});
export default CardNamespace;
